<template>
  <ContentSection skew="right" class="bg-astralblue-400 mx-auto py-5 pt-12 pb-20 block">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12">
        <h2 class="text-white font-medium my-2 text-3xl">What we do</h2>
        <p class="pb-5 text-2xl font-light text-white">
          Our capabilities cover a wide range of business, IT, and enterprise domains. We work
          collaboratively with you to understand your business needs so we can deliver high quality
          outcomes.
        </p>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-3">
      <div class="col-span-12" v-for="item in data" :key="item.id">
        <div class="card shadow card_wwd py-5 relative">
          <div class="card-content">
            <svgicon :name="'services/icon-' + item.id" width="50" />
            <h3
              class="text-2xl font-medium text-astralblue-500 leading-snug pl-5 ml-10"
              v-html="item.name"
            ></h3>
            <p class="text-sm leading-6 pl-5 ml-10">
              <span v-for="(service, key) in item.children" :key="key">
                <span v-html="service"></span>
                <span v-show="key < item.children.length - 1"> / </span>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </ContentSection>
</template>

<script>
import '@/components/svg/services';
import ContentSection from '@/components/ContentSection.vue';
export default {
  name: 'HomeWhatWeDo',
  components: { ContentSection },
  data: function() {
    return {
      focusedService: null
    };
  },
  computed: {
    data: {
      get: function() {
        return this.Store.servicesb;
      },
      set: function() {}
    }
  },
  methods: {
    addHover: function(id) {
      this.focusedService = id;
    },
    remHover: function() {
      if (this.focusedService !== null) {
        this.focusedService = null;
      }
    }
  },
  created() {}
};
</script>

<style lang="scss"></style>
